import { IRankingChangeTableHeaderProps } from '@/pages/dashboard/pages/changeAnalysis/components/RankingChangeTable/components/RankingChangeTableHeader/type';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { getName } from '@home/utils/common';
import { navigate } from '@home/utils/utils';
import React, { FC, useContext } from 'react';
import classNames from 'classnames';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';
import './index.scss';

export const RankingChangeTableHeader: FC<IRankingChangeTableHeaderProps> = (props) => {
  const {
    gameIcon,
    url,
    column,
  } = props;

  const { filterVal } = useContext(FilterContext);
  const { nameEn, nameCn, name } = column || {};
  const { isEN } = useLocal();
  const gameName = getName(isEN, nameEn, nameCn) || name;

  const handleClick = () => {
    if (!url) return;

    const { period, start_date: startDate, end_date: endDate } = filterVal || {};

    let resolvedUrl = url;
    if (period && startDate && endDate) {
      const periodMap: Record<string, string> = {
        daily: 'day',
        weekly: 'week',
        monthly: 'month',
      };
      const normalizedPeriod = periodMap[period] || period;
      const rangeTimeParam = `rangeTime=${normalizedPeriod},${startDate},${endDate}`;
      resolvedUrl = url.includes('?')
        ? `${url}&${rangeTimeParam}`
        : `${url}?${rangeTimeParam}`;
    }

    navigate(resolvedUrl, { jumpType: 'window' });
  };

  return (
    <div
      className={classNames('dbd-ranking-change-table__game-header', {
        'dbd-ranking-change-table__game-header--clickable': url,
      })}
      onClick={handleClick}
    >
      <div className="dbd-ranking-change-table__game-header__content">
        <div className="dbd-ranking-change-table__game-header__logo">
          {gameIcon && (
            <img
              src={gameIcon}
              alt={gameName}
              className="dbd-ranking-change-table__game-header__logo__img"
            />
          )}
        </div>
        <span className="dbd-ranking-change-table__game-header__name">
          {gameName}
        </span>
      </div>
    </div>
  );
};
